import type { CommonStylesPalette } from '../types.d';

export const commonDoubleListBoxStyle = ({ palette = {} as CommonStylesPalette }) => ({
  '& .doubleListBox.layout-columns': {
    '& .layout-columns-container.row': {
      '& .layout-columns-element.col-sm-6': {
        '&>.row': {
          '&>.col-sm-12': {
            '& .panel-form': {
              '& .panel-body': {
                '& .dlb-source-container, & .dlb-selected-container': {
                  '& .dlb-source.dlb-source-list, & .dlb-selected.dlb-selected-list': {
                    outline: 'none',

                    '&:empty:focus': {
                      border: `1px solid ${palette.neutralSecondary}`,
                    },

                    '& .dlbItem': {
                      '&:hover': {
                        backgroundColor: palette.neutralLighter,
                      },

                      '&.k-state-focused': {
                        border: `1px solid ${palette.neutralSecondary}`,
                      },

                      '&.k-state-selected, &.selected': {
                        backgroundColor: palette.neutralLight,
                      },
                    },
                  },
                },

                '& .dlb-source-container .dlb-source.dlb-source-list .selectable-treeview .dlbItem': {
                  '& .dlbItem-content': {
                    '& .audience-association-selector-item-table': {
                      '& .tree-item': {
                        outline: 'none',

                        '&.active': {
                          backgroundColor: palette.neutralLight,
                        },
                        '&.focus': {
                          border: `1px solid ${palette.neutralSecondary}`,
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
});
